import { render } from "./ExplanationComponent.vue?vue&type=template&id=5054c61a&scoped=true"
import script from "./ExplanationComponent.vue?vue&type=script&lang=js"
export * from "./ExplanationComponent.vue?vue&type=script&lang=js"

import "./ExplanationComponent.vue?vue&type=style&index=0&id=5054c61a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5054c61a"]])

export default __exports__